module.exports = __webpack_public_path__ + "static/media/BoxPlotQ7_5.c90cbe30.svg";